import {Loader as MapLoader} from '@googlemaps/js-api-loader/dist/index.mjs';

export default (new MapLoader({
  apiKey: 'AIzaSyAlYs1VyubzpLaVhRnMA7TH-XJxmP8kCFc',
  version: 'weekly',
  libraries: [
    'places'
  ],
  fields: [
    'formatted_address',
    'geometry',
  ],
}));
